import React, { useState } from 'react'
import style from './style'
import propTypes from './prop'
import ClassNames from 'classnames'
import FormFactory from '../../form-item/factory'
import { FormStateModeType } from '../../../../form/props'
import { withStyles, Grid, Typography, Collapse } from '@material-ui/core'
import { CoreIconButton } from 'src/components/core'
import { Icon } from '@iconify/react'
const FormItemGroup = props => {
  const {
    classes,
    expanded,
    collapsible,
    label,
    formItems,
    id,
    dispatch,
    stateMode,
  } = props
  const [expand, setExpand] = useState(expanded)

  /**
   *
   * @param {*} e
   */
  const handleExpand = e => {
    setExpand(!expand)
  }

  return (
    <Grid className={classes.root} container>
      {label && (
        <Grid
          className={classes.header}
          container
          justifyContent="center"
          alignItems="center"
          onClick={handleExpand}
        >
          <Grid item className={classes.labelWrapper}>
            <Typography variant="body1" className={classes.label}>
              {label}
            </Typography>
          </Grid>

          <Grid item>
            <CoreIconButton
              color="primary"
              variant="text"
              size="small"
              className={ClassNames(classes.expand, {
                [classes.expandOpen]: expand,
                [classes.iconHidden]: !collapsible,
              })}
              aria-expanded={expanded}
            >
              <Icon icon="ic:round-expand-more" />
            </CoreIconButton>
          </Grid>
        </Grid>
      )}

      <Collapse
        className={classes.collapse}
        in={expand}
        timeout="auto"
        unmountOnExit
      >
        {formItems.map(formItem => {
          formItem.groupId = id
          formItem.dispatch = dispatch

          if (formItem.hidden) {
            return ''
          }
          if (stateMode == FormStateModeType.UPDATE && formItem.hiddenEdit) {
            return ''
          }

          return FormFactory({ ...formItem, stateMode })
        })}
      </Collapse>
    </Grid>
  )
}

FormItemGroup.propTypes = propTypes

export default withStyles(style)(FormItemGroup)
